<div class="navigation-bar">
  <a
    [ngClass]="{ 'active-link': isHomeRouteActive }"
    [routerLink]="['']"
    (click)="trackCTAEvent('Discover', '')"
    class="navigation-bar_item flex"
  >
    <div class="relative">
      <stxt-svg-icon
        class="navigation-bar_icon enabled absolute"
        [iconConfig]="homeSvg"
      ></stxt-svg-icon>
      <stxt-svg-icon
        class="navigation-bar_icon hovered"
        [iconConfig]="homeFilledSvg"
      ></stxt-svg-icon>
    </div>
    <p class="navigation-bar_title">Discover</p>
  </a>
  <a
    [ngClass]="{ 'active-link': isChatRouteActive }"
    (click)="openChat()"
    (keydown.enter)="openChat()"
    tabindex="0"
    class="navigation-bar_item flex btn-nostyle position-relative"
  >
    <div class="relative">
      <stxt-svg-icon
        class="navigation-bar_icon enabled absolute"
        [iconConfig]="chatSvg"
      ></stxt-svg-icon>
      <stxt-svg-icon
        class="navigation-bar_icon hovered"
        [iconConfig]="chatFilledSvg"
      ></stxt-svg-icon>
      <span *ngIf="(unreadMessagesCount$ | async) > 0" class="unread-badge">
        <!-- Commenting this as updated design not require this -->
        <!-- {{ (unreadMessagesCount$ | async) > 99 ? '99+' : (unreadMessagesCount$ | async) }} -->
      </span>
    </div>
    <span class="navigation-bar_title">Chat</span>
  </a>
  <a
    routerLinkActive="active-link"
    [routerLink]="['/generate']"
    [routerLinkActiveOptions]="{ exact: true }"
    class="navigation-bar_item flex"
  >
    <div class="relative">
      <stxt-svg-icon
        class="navigation-bar_icon enabled absolute"
        [iconConfig]="generateSvg"
      ></stxt-svg-icon>
      <stxt-svg-icon
        class="navigation-bar_icon hovered"
        [iconConfig]="generateFilledSvg"
      ></stxt-svg-icon>
      <div class="unread-badge" *ngIf="unreadGenerationsCount > 0 && pageUrl !== '/generate'">
        <!-- Commenting this as updated design not require this -->
        <!-- {{ unreadGenerationsCount > 99 ? '99+' : unreadGenerationsCount }} -->
      </div>
    </div>
    <span class="navigation-bar_title">Generate</span>
  </a>
  <div
    (click)="toggleUnlock()"
    (keydown.enter)="toggleUnlock()"
    tabindex="0"
    class="navigation-bar_item unlock_nav"
  >
    <stxt-svg-icon class="navigation-bar_icon" [iconConfig]="tokenSvg"></stxt-svg-icon>
    <span class="navigation-bar_title">Unlock</span>
  </div>
</div>
